import leadsReceptionsDashboardReceivedLeads from './leads-receptions-dashboard-received-leads'
import leadsReceptionsDashboardQualifiedUnqualifiedLeads from './leads-receptions-dashboard-qualified-unqualified-leads'
import leadsReceptionsDashboardBrokerPerformance from './leads-receptions-dashboard-broker-performance'
import leadsReceptionsDashboardEntryReentryLeads from './leads-receptions-dashboard-entry-reentry-leads'
import leadsReceptionsDashboardUnqualifiedReasons from './leads-receptions-dashboard-unqualified-reasons'

export default {
  leadsReceptionsDashboardReceivedLeads,
  leadsReceptionsDashboardQualifiedUnqualifiedLeads,
  leadsReceptionsDashboardBrokerPerformance,
  leadsReceptionsDashboardEntryReentryLeads,
  leadsReceptionsDashboardUnqualifiedReasons
}
